import { PaginatedQueryParams, usePaginatedQuery } from '@/hooks/use-paginated-query';
import { UserPermissionData } from '@/types/User/UserPermissionData';

type Params = PaginatedQueryParams & {
  users: string[];
};

export const useGetUserTeamsQuery = ({ ...params }: Params) => {
  return usePaginatedQuery<UserPermissionData>({
    queryKey: ['admin/team', params.users, params.current, params.pageSize, params.sort, params.search],
    url: `admin/team`,
    params: {
      ...params,
      params: {
        users: params.users,
      },
    },
  });
};
